export default __webpack_public_path__ + "static/SmartViewPrint1-e315cb80b0defdcd0bc8e4561281d438.webp";